function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Text4 } from "@churchofjesuschrist/eden-text";
import { spacing4, spacing8 } from "@churchofjesuschrist/eden-style-constants";
import { linkRowContainer, labelContainer, badgeContainer } from "./shared";
const RowContainer = styled.a.withConfig({
  componentId: "sc-kt91c2-0"
})(["", ";text-decoration:none;"], linkRowContainer);
const spacingAlignmentOffset = "-2px";
const IconContainer = styled.div.withConfig({
  componentId: "sc-kt91c2-1"
})(["display:flex;align-items:baseline;margin-block-start:", ";margin-block-end:", ";margin-inline-start:-", ";padding-inline-end:", ";"], spacingAlignmentOffset, spacingAlignmentOffset, spacing4, spacing8);
const LabelContainer = styled(Text4).withConfig({
  componentId: "sc-kt91c2-2"
})(["", ";min-width:0;"], labelContainer);
const BadgeContainer = styled.div.withConfig({
  componentId: "sc-kt91c2-3"
})(["", ";"], badgeContainer);
const NavigationBlockLink = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    href,
    active = false,
    icon = null,
    badge = null,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(RowContainer, _extends({
    href: href
  }, active ? {
    "aria-current": "page"
  } : {}, {
    active: active
  }, rest, {
    ref: ref
  }), icon ? /*#__PURE__*/React.createElement(IconContainer, null, icon) : null, /*#__PURE__*/React.createElement(LabelContainer, null, children), badge ? /*#__PURE__*/React.createElement(BadgeContainer, null, badge) : null);
});
NavigationBlockLink.displayName = "NavigationBlockLink";
NavigationBlockLink.propTypes = {
  /** The contents of the link */
  children: PropTypes.node.isRequired,

  /** The URL that the hyperlink points to */
  href: PropTypes.string.isRequired,

  /** Whether the link is currently active */
  active: PropTypes.bool,

  /** An eden-icon */
  icon: PropTypes.element,

  /** An eden-badge */
  badge: PropTypes.element
};
export default NavigationBlockLink;